
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {
        dictApi,
        dictInstrumentApi,
    } from "@/api/organization";
    import AddManufactory from "@/components/AddManufactory.vue";
    import tempSave from "@/components/TempSave.vue";
    import reasons from '@/components/Reasons.vue'
    const {CodeToText, regionData} =require("@/js/region/region");
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import StandardApparatus from "@/components/StandardApparatus.vue";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
    import SelectRules from "@/components/SelectRules.vue";
    @Component({
        name: "Sys_InstrumentName_Detail",
        components: {SelectRules,AddManufactory,reasons,tempSave, ckeditor4, ElImageViewer, StandardApparatus}
    })
    export default class Home extends Vue {
        title = "器具字典详情";
        pageType = "0";  //0添加  1编辑  2查看
        id = "0";   //器具id
        form = {
            /**
             * '器具名称'
             */
            name: "",
            /**
             * 器具类别
             */
            name2: [],
            /**
             * 规程规范
             */
            rulesArr: [{number: "", name: ""}],
            /**
             * 是否列入强制检定器具目录
             */
            strong: "",
            /**
             * 强检目录是否有参数限制
             */
            isMustPassParam: "",
            /**
             * 上限值
             */
            upperLimit: "",
            /**
             * 下限值
             */
            lowerLimit: "",
            /**
             * 目录
             */
            catalogue: [],
            /**
             * 检定/校准周期
             */
            checkCycle: '',
        } as any
        rules = {
            name: [{ required: true, message: '请输入器具名称', trigger: 'blur' }],
            name2: [{ required: true, message: '请选择器具专业/种别/项别', trigger: 'blur' }],
            rulesArr: [{ required: true, message: '请设置规程规范', trigger: 'blur' }],
            rulesNumber: [{ required: true, message: '请输入规程规范编号', trigger: 'change' }],
            strong: [{ required: true, message: '请选择是否强检', trigger: 'change' }],
            catalogue: [{ required: true, message: '请选择强检一级目录/强检二级目录', trigger: 'change' }],
            isMustPassParam: [{ required: true, message: '请选择强检目录是否有参数限制', trigger: 'change' }],
            lowerLimit: [{ required: true, message: '请输入下限值', trigger: 'blur' }],
            upperLimit: [{ required: true, message: '请输入上限值', trigger: 'blur' }],
        }
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        private closePage: any;
        props = {
            value: 'id',
            label: 'name',
        }
        showAllLevels = true;
        listInstrument = [] as any; //器具备选列表
        instrCatalogueTree = [] as any;
        loading = false;


        mounted() {
            this.init();
        }
        init(){
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            this.loading = true;
            this.getListInstrument()
        }
        //获取器具详情
        getDetail(){
            dictInstrumentApi.getOne({id:this.id}).then(r=>{
                this.loading = false;
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    // try {
                    //     const obj=JSON.parse(rData.ranges);
                    //     if(typeof obj == 'object' && obj ){
                    //         rData.paramList = obj;
                    //     }
                    // } catch (e) {
                    //     console.log(e)
                    // }
                    rData.strong = String(rData.strong);
                    if(rData.rules){
                        const arr = rData.rules.split("】/");
                        const arr2 = [] as any;
                        for(let i = 0; i < arr.length; i++){
                            let thisArr = arr[i];
                            if(i != arr.length - 1 && arr.length > 1){
                                thisArr += "】";
                            }
                            const arr3 = thisArr.split("【");
                            let number = "";
                            let name = "";
                            if(arr3.length > 1){
                                number = arr3[0];
                                const reg = new RegExp(/(?<=【).*?(?=】)/,'g');
                                // const reg = new RegExp(/【(.+)$/,'g');
                                name = thisArr.match(reg)[0];
                            }else{
                                const arr4 = thisArr.split(",");
                                if(arr4.length > 1){
                                    number = arr4[0];
                                    name = arr4[1];
                                }
                            }
                            arr2.push({number: number, name: name});
                        }
                        rData.rulesArr = arr2;
                    }
                    for(const n1 of this.listInstrument){
                        if(n1.children){
                            for(const n2 of n1.children){
                                if(n2.children){
                                    for(const n3 of n2.children){
                                        if(n3.id === rData.parentId){
                                            rData.name2 = [n1.id,n2.id,n3.id];
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(rData.catalogueOne && rData.catalogueTwo){
                        rData.catalogue = [rData.catalogueOne, rData.catalogueTwo];
                    }
                    this.form = Object.assign(this.form, rData);
                    // this.form.useAddrCodeArr = rData.useAddrCode ? rData.useAddrCode.split(",") : [];
                    // this.$nextTick(()=>{
                    //     const arr = [];
                    //     arr.push(Number(rData.majorCode));
                    //     arr.push(Number(rData.classCode));
                    //     arr.push(Number(rData.categoryCode));
                    //     arr.push(Number(rData.instrumentNameId));
                    //     this.form.name = arr;
                    //     // this.initFormInstrumentCode(arr);
                    // })
                }
            })
        }
        //获取器具备选列表个
        getListInstrument(){
            dictApi.listDictInstrument().then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData, 0);
                    this.listInstrument = rData;

                    if(this.pageType != "0"){
                        this.getDetail();
                    }else{
                        this.loading = false;
                    }
                }
            });
            dictApi.listInstrumentCatalogueTree().then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTreeV2(rData);
                    this.instrCatalogueTree = rData;
                }
            });
        }
        porjectTreeV2(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length == 0){
                    project.children = null;
                }else{
                    this.porjectTreeV2(project.children);
                }
            })
        }
        porjectTree(projectList: any, level: number){
            projectList.forEach((project: any) => {
                if(level === 2){
                    project.children = null;
                }else{
                    this.porjectTree(project.children, (level+1));
                }
            })
        }
        nameChange(value: any){
            if(value.length >= 4){
                this.form.measureRange = [];
            }
        }
        onSubmit() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    let params = {
                        ...this.form
                    }
                    params.parentId = params.name2[params.name2.length-1];
                    // params.ranges = JSON.stringify(params.paramList);
                    const arr = [] as any;
                    params.rulesArr.forEach((e: any) => {
                      if(e.number){
                        arr.push(e.number+"【"+e.name+"】")
                      }
                    })
                    params.rules = arr.join("/");
                    // 如果隐藏了规程规范和是否强检，清空
                    if(!this.showRulesAndStrong('rule')){
                        params.rules = "";
                    }
                    if(!this.showRulesAndStrong('strong')){
                      params.strong = "0";
                    }

                    //如果非强检，清除测量范围
                    if(params.strong != '1'){
                        params.ranges = null;
                        params.catalogueOne = null;
                        params.catalogueTwo = null;
                    }else{
                        params.catalogueOne = params.catalogue[0];
                        params.catalogueTwo = params.catalogue[1];
                    }
                    const loading = this.$loading({
                        text: '正在保存',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    dictInstrumentApi.addOrUpdateInstrument(params).then(r=>{
                        if(r.data.result === 0){
                            this.$message.success("保存成功");
                            this.closePage();
                        }
                        loading.close();
                    })
                }
            });

        }
        //测量范围************************************************
        // addSurveyRanges = {
        //     visible: false,
        //     surveyRanges: [],
        //     params: null as any,
        // }
        // cloneObjectFn(obj: any) {
        //     return JSON.parse(JSON.stringify(obj));
        // }
        //
        // openAddSurveyRangesDiglog(surveyRanges: any) {
        //     surveyRanges = this.cloneObjectFn(surveyRanges);
        //     this.addSurveyRanges.surveyRanges = surveyRanges;
        //     this.addSurveyRanges.params = {};
        //     this.addSurveyRanges.visible = true;
        // }
        //
        // closeAddSurveyRangesDiglog() {
        //     this.addSurveyRanges.visible = false;
        //     this.addSurveyRanges.surveyRanges = [];
        //     this.addSurveyRanges.params = null;
        // }
        //
        // submitAddSurveyRanges(e: any) {
        //     let paramList = this.cloneObjectFn(e.paramList);
        //     this.form.paramList = paramList;
        //     this.closeAddSurveyRangesDiglog();
        // }
        //测量范围end************************************************

        //规程规范********************************
        //代替规程编号查询后
        replaceRulesChange(e: any){
            if(e){
                const rData = this.form.rulesArr[e.rowIndex];
                if(rData){
                    rData.number = e.number;
                    rData.name = e.name;
                }
            }
        }
        addData(){
            const rulesArr: any = this.form.rulesArr;
            const data = {number: "", name: ""};
            rulesArr.push(data);
        }
        deleteData(index: number){
            this.form.rulesArr.splice(index, 1);
            // this.loading = true;
            // this.$nextTick(()=>{
            //     this.loading = false;
            // })
        }
        //规程规范end********************************
        checkRule(index: number){
          if(this.form.name2 && this.form.name2.length > 0){
            if(this.form.name2[2] == 3002){
              return "";
            }
          }

          return 'rulesArr.'+ index + '.number';
        }
        // 隐藏规程规范和强检器具选项
        showRulesAndStrong(mode: string){
            if(this.form.name2 && this.form.name2.length > 0){
                // 类别是化学  和 第三级是  其它配套设备
                if(mode === 'rule' && this.form.name2[2] == 3002){
                  return true;
                }
                if(this.form.name2[1] == 3001 || this.form.name2[2] == 6163){
                    return false;
                }
            }
            return true;
        }
    }
